import { formatPrice } from '@utils/prices';

import { CurrencyCode } from '../../types/Locations';

export const preferenceOrdinalKey = (rank: number): string => {
  if (rank === 1) return '1';
  if (rank === 2) return '2';
  if (rank === 3) return '3';
  return 'other';
};

export const getPreferenceLabelKeys = (rank: number, isBackup: boolean) => ({
  ordinalKey: `orderReview.preferenceOrdinal.${preferenceOrdinalKey(rank)}`,
  choiceKey: isBackup
    ? 'orderReview.preferenceChoiceBackup'
    : 'orderReview.preferenceChoice',
});

export const computeOrderTotals = ({
  currencyCode,
  maxQuantity,
  prices,
}: {
  currencyCode: CurrencyCode;
  maxQuantity: number;
  prices: number[];
}): {
  isEstimate: boolean;
  maxOrderValue: string;
  orderValue: string;
  shippingCost?: string;
} => {
  if (prices.length === 0) {
    return {
      isEstimate: false,
      maxOrderValue: String(formatPrice(0, currencyCode)),
      orderValue: String(formatPrice(0, currencyCode)),
      shippingCost: undefined,
    };
  }

  const total = prices.reduce((sum, price) => sum + price, 0);
  const wins = Math.min(maxQuantity, prices.length);
  const sorted = [...prices].sort((a, b) => a - b);
  const minPayable = sorted
    .slice(0, wins)
    .reduce((sum, price) => sum + price, 0);
  const maxPayable = sorted
    .slice(sorted.length - wins)
    .reduce((sum, price) => sum + price, 0);

  const isEstimate = wins < prices.length && minPayable !== maxPayable;

  return {
    isEstimate,
    maxOrderValue: String(formatPrice(maxPayable, currencyCode)),
    orderValue: isEstimate
      ? `${formatPrice(minPayable, currencyCode)}–${formatPrice(maxPayable, currencyCode)}`
      : String(formatPrice(total, currencyCode)),
    shippingCost: undefined,
  };
};
